export default "__VITE_ASSET__C6qgzwo7__"